module.exports = __webpack_public_path__ + "img/2.079ceb8b.svg";